import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const postList = dom.target.querySelectorAll('.js-post');
    const searchInput = dom.target.querySelector('.js-search-input');
    const categorySelect = dom.target.querySelector('.js-category');

    if (postList.length && searchInput) {
        const filterPosts = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            postList.forEach(post => {
                const title = post.querySelector('.content__title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const postTerms = JSON.parse(post.dataset.terms || '[]');

                const matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                const matchCategory = categorySelect.value === '' || postTerms.includes(categorySelect.value);

                if (matchSearch && matchCategory) {
                    post.classList.remove('hidden');
                } else {
                    post.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterPosts, 300);
        searchInput.addEventListener('input', handleInput);

        categorySelect.addEventListener('change', filterPosts);

        filterPosts();
    }
});
